export default __webpack_public_path__ + "static/media/kenya.92f54c69.svg";